import React, { useEffect } from "react";
import palette from "./palette.js";
import lightStyles from "./lightStyles"
import darkStyles from "./darkStyles"

const styles = {
    light: lightStyles,
    dark: darkStyles
}

/**
 * Template function does nothing, but webstorm uses it to properly syntax highlight css
 */
const css = (strings, ...values) => {
    return strings.map(function(e, i) {
        return [e, values[i]];
    }).flat().join(" ");
};

const ThemeProvider = React.memo(({ children, theme, isRoot }) => {
    useEffect(() => {
        if(isRoot) {
            const style = styles[theme];
            if(!style) {
                return;
            }

            const styleTag = window.document.createElement('style');
            const generatedString = style(css, palette);
            styleTag.innerHTML = `
                :root, ::before, ::after {
                    ${generatedString};
                    ${theme === "dark" ? "color-scheme: dark;" : ""}
                }
            `;
            ThemeProvider.activeStyles = generatedString;

            document.head.appendChild(styleTag);

            return () => {
                document.head.removeChild(styleTag);
            }
        }
    }, [theme, isRoot]);

    return <>
        {children}
    </>
});

export default ThemeProvider;